// src/components/PilahSampah/PilahSampahLevelScreen.js
import React from 'react';
import styles from './PilahSampah.module.css';
import { ACTIONS } from './PilahSampahGame';
import { playButtonSound } from '../../utils/audioUtils'; // Impor suara

// ==========================================================
// PERBAIKAN DI SINI: `style` sekarang adalah objek JavaScript
// ==========================================================
const levels = [
    { 
        id: 'easy', 
        text: 'MUDAH', 
        description: 'Sampah umum sehari-hari', 
        className: styles.btnPrimary // Gunakan kelas CSS untuk konsistensi
    },
    { 
        id: 'medium', 
        text: 'SEDANG', 
        description: 'Campuran berbagai jenis', 
        className: styles.btnSecondary 
    },
    { 
        id: 'pro', 
        text: 'PRO', 
        description: 'Sampah khusus & B3', 
        // Untuk gaya yang sangat spesifik, kita gunakan objek style
        style: { 
            background: 'linear-gradient(135deg, #9C27B0, #7B1FA2)', 
            color: 'white' 
        } 
    },
];

function PilahSampahLevelScreen({ dispatch }) {
    
    const handleSelect = (difficulty) => {
        playButtonSound();
        dispatch({ type: ACTIONS.SELECT_DIFFICULTY, payload: difficulty });
    };

    const handleBack = () => {
        playButtonSound();
        dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: 'menu' });
    };

    return (
        <div className={`${styles.screen} ${styles.menuScreen} ${styles.active}`}>
            <div className={styles.gameLogo}>
                <div className={styles.trophyIcon}>🎯</div>
                <h1>Pilih Level</h1>
                <p>Sesuaikan tingkat kesulitan</p>
            </div>
            <div className={styles.menuButtons}>
                {levels.map(level => (
                    <button 
                        key={level.id}
                        // Gunakan className JIKA ada, jika tidak gunakan style.
                        // Ini membuat kode lebih fleksibel.
                        className={`${styles.btn} ${level.className || ''}`} 
                        style={level.style || {}} 
                        onClick={() => handleSelect(level.id)}
                    >
                        <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                            <strong>{level.text}</strong>
                            <span style={{fontSize: '14px', opacity: 0.9}}>{level.description}</span>
                        </div>
                    </button>
                ))}
                <button 
                    className={styles.btn} 
                    style={{ background: '#607D8B', color: 'white', marginTop: '20px' }}
                    onClick={handleBack}
                >
                    ← Kembali
                </button>
            </div>
        </div>
    );
}

export default PilahSampahLevelScreen;